//This file will check if a user is logged in and grant access to protected routes.
//It implemets the AutoLogout hook to manage automatic logout for users upon token expiration.
import { Outlet } from 'react-router-dom';
import { useSubStatus } from '../hooks/useSubStatus';
import { toast } from 'react-toastify';

const PrivateSubscriptionRoute = () => {
    const { subStatus, checkingSubStatus } = useSubStatus();

    // Wait until subscription status is checked
    if (checkingSubStatus) {
        return <div>Loading...</div>;
    }

    // Allow access only if subscription is trialing or active
    if (subStatus === 'trialing' || subStatus === 'active') {
        return <Outlet />;
    }

    // Show a toast message and prevent navigation
    toast.error('Access denied. Please check your subscription status.');
    return null; // Render nothing, stay on the current page
};

export default PrivateSubscriptionRoute;